// https://developers.google.com/web/tools/workbox/modules/workbox-window
import { Workbox } from 'workbox-window'
import $storage from '../storage/storage.js'

export default function registerServiceWorker () {
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('sw.js')

    wb.addEventListener('installed', event => {
      console.log("instalou sw.js")
      if (event.isUpdate) {
        if (
          confirm('Nova atualização disponível!. Clique em OK para atualizar')
        ) {
          window.location.reload()
        }
      }

      // NOTIFICAÇÃO
      if ('PushManager' in window) {
        const isNotify = (Notification.permission === 'granted') ? true : false;
        if (!Notification.permission) {
          Notification.requestPermission(async (outcome) => {
            if (outcome === 'granted') {
              $storage.set('isNotify', true);
            } else {
              $storage.set('isNotify', false);
            }
          });
        }
      }
    })
    wb.register()
  }
}


/*
* INSTALAR DESKTOP
*/

let deferredPrompt;
let isInstalled = $storage.get('pwaInstalled') || false;

if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
  // User is currently navigating on the PWA so yes it's installed
  $storage.set('pwaInstalled', true);
  isInstalled = true;
} else {

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    $storage.set('pwaInstalled', false);
    isInstalled = false;
  });
  window.addEventListener('appinstalled', async () => {
    deferredPrompt = null;
    console.log('App foi instalado');
    $storage.set('pwaInstalled', true);
    isInstalled = true;
  });
}
